import type { DrawerContent } from '../../../CartConfirmDrawer/model/useCartConfirmDrawer';

type GetAddedToAutoshipContentParams = {
    nextSubscriptionDate: Maybe<string>;
    onViewOrder?: () => void;
};

/** Cart confirm drawer copy shown after an item is added to the shopper's next Autoship order. */
export const getAddedToAutoshipContent = ({
    nextSubscriptionDate,
    onViewOrder,
}: GetAddedToAutoshipContentParams): DrawerContent => {
    const nextOrderDate = nextSubscriptionDate
        ? new Date(nextSubscriptionDate).toLocaleString('en-US', {
              month: 'short',
              weekday: 'short',
              day: 'numeric',
              timeZone: 'UTC',
          })
        : null;

    return {
        title: 'Added to Autoship',
        subtitle: nextOrderDate ? `Item(s) added to your next Autoship order on ${nextOrderDate}.` : '',
        primaryAction: { text: 'View order', href: '/account/auto-ship', onClick: onViewOrder },
    };
};
